import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lonniyire-spinner',
  imports: [],
  template: `
    <div class="flex items-center justify-center" [class.py-6]="!inline()">
      <div
        class="inline-block animate-spin rounded-full border-4 border-solid border-current
          border-t-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status"
        [class]="sizeClass">
        <span class="sr-only">{{ label() }}</span>
      </div>
    </div>
  `,
})
export class Spinner {
  readonly size = input<'sm' | 'md' | 'lg'>('md');
  readonly inline = input(false);
  readonly label = input('Loading...');

  get sizeClass(): string {
    return { sm: 'h-5 w-5 border-2', md: 'h-8 w-8', lg: 'h-12 w-12' }[this.size()];
  }
}
